
function App() {
  return (
    <div className="App">
      サンプル
    </div>
  );
}

export default App;
